define('modules/shell/widgets/datepicker/i18n/fr',{
    "datepicker":{
        "clear":"Clair"
    }
});

